import fetch from 'node-fetch';

export const getSelfTestPublishedVersion = () => {
  return fetch('selfTest.json', {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  }).then(function (response) {
    return response.json();
  });
};
